// // 1. First, let's create the EnrollmentModal Component that will be imported in ClassroomPage

// // components/EnrollmentModal.jsx
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../context/AuthContext";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { CONSTANTS } from "../constants/Constants";

// const EnrollmentModal = ({ isOpen, onClose, courseDetails }) => {
//   const { currentUser, userDetails } = useAuth();
//   const [step, setStep] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [installments, setInstallments] = useState(1);
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//     city: "",
//     state: "",
//     pincode: "",
//     education: "",
//     paymentType: "full",
//     couponCode: "",
//     schoolName: "",
//   });

//   // Initialize form with user data if logged in
//   useEffect(() => {
//     if (userDetails) {
//       setFormData({
//         ...formData,
//         name: `${userDetails.firstName || ""} ${
//           userDetails.lastName || ""
//         }`.trim(),
//         email: userDetails.email || "",
//         phone: userDetails.phone || "",
//         address: userDetails.address || "",
//         city: userDetails.city || "",
//         state: userDetails.state || "",
//         pincode: userDetails.pincode || "",
//         education: userDetails.education || "",
//       });
//     }
//   }, [userDetails]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handlePaymentTypeChange = (e) => {
//     setFormData({
//       ...formData,
//       paymentType: e.target.value,
//     });
//   };

//   const handleInstallmentsChange = (e) => {
//     setInstallments(parseInt(e.target.value));
//   };

//   const validateStep1 = () => {
//     // Basic validation
//     if (!formData.name || !formData.email || !formData.phone) {
//       toast.error("Please fill all required fields");
//       return false;
//     }

//     // Email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       toast.error("Please enter a valid email address");
//       return false;
//     }

//     // Phone validation
//     const phoneRegex = /^\d{10}$/;
//     if (!phoneRegex.test(formData.phone.replace(/\D/g, ""))) {
//       toast.error("Please enter a valid 10-digit phone number");
//       return false;
//     }

//     return true;
//   };

//   const handleNextStep = () => {
//     if (step === 1 && validateStep1()) {
//       setStep(2);
//     } else if (step === 2) {
//       setStep(3);
//     }
//   };

//   const handlePrevStep = () => {
//     if (step > 1) {
//       setStep(step - 1);
//     }
//   };

//   const calculateInstallmentAmount = () => {
//     const fullPrice = parseFloat(courseDetails.price.replace(/[^\d.]/g, ""));
//     // Adding 5% processing fee for installments
//     const totalWithFee =
//       formData.paymentType === "part" ? fullPrice * 1.05 : fullPrice;

//     if (formData.paymentType === "part") {
//       return Math.ceil(totalWithFee / installments);
//     }

//     return totalWithFee;
//   };

//   const initializeRazorpay = async () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => {
//         resolve(true);
//       };
//       script.onerror = () => {
//         resolve(false);
//       };
//       document.body.appendChild(script);
//     });
//   };

//   const handlePayment = async () => {
//     try {
//       setIsLoading(true);

//       // Initialize Razorpay
//       const res = await initializeRazorpay();

//       if (!res) {
//         toast.error("Razorpay SDK failed to load");
//         setIsLoading(false);
//         return;
//       }

//       // Prepare enrollment data
//       const enrollmentData = {
//         userId: currentUser?.uid || null,
//         courseId: courseDetails.id,
//         courseTitle: courseDetails.title,
//         studentName: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         address: formData.address,
//         city: formData.city,
//         state: formData.state,
//         pincode: formData.pincode,
//         education: formData.education,
//         paymentType: formData.paymentType,
//         totalInstallments: formData.paymentType === "part" ? installments : 1,
//         currentInstallment: 1,
//         amountPaid: 0,
//         totalAmount: parseFloat(courseDetails.price.replace(/[^\d.]/g, "")),
//         couponCode: formData.couponCode,
//         status: "pending",
//       };

//       // Create an enrollment record and get order details

//       const response = await axios.post(
//         `${CONSTANTS.APIURL}/api/enrollments`,
//         enrollmentData
//       );
//       console.log("Enrollment response:", response);

//       const { orderId, amount, enrollmentId } = response.data;

//       // Razorpay payment options
//       const options = {
//         key: "rzp_test_3xev9wR08EwOcs", // Replace with your actual Razorpay key
//         amount: amount * 100, // Amount in paisa
//         currency: "INR",
//         name: "Skysep",
//         description: `Enrollment for ${courseDetails.title}`,
//         order_id: orderId,
//         handler: async function (response) {
//           try {
//             // Verify payment and update enrollment status
//             const paymentData = {
//               enrollmentId,
//               paymentId: response.razorpay_payment_id,
//                 orderId: response.razorpay_order_id,
//               signature: response.razorpay_signature,
//             };

//             await axios.post(
//               `${CONSTANTS.APIURL}/api/enrollments/verify-payment`,
//               paymentData
//             );

//             toast.success(
//               "Payment successful! You are now enrolled in the course."
//             );
//             setIsLoading(false);
//             onClose();

//             // Redirect to dashboard or course page
//             window.location.href = "/dashboard";
//           } catch (error) {
//             console.error("Payment verification error:", error);
//             toast.error("Payment verification failed. Please contact support.");
//             setIsLoading(false);
//           }
//         },
//         prefill: {
//           name: formData.name,
//           email: formData.email,
//           contact: formData.phone,
//         },
//         notes: {
//           enrollmentId,
//           courseId: courseDetails.id,
//           installment: `1/${
//             formData.paymentType === "part" ? installments : 1
//           }`,
//         },
//         theme: {
//           color: "#4B5563",
//         },
//         modal: {
//           ondismiss: function () {
//             setIsLoading(false);
//           },
//         },
//       };

//       const paymentObject = new window.Razorpay(options);
//       paymentObject.open();
//     } catch (error) {
//       console.error("Enrollment error:", error);
//       toast.error(
//         error.response?.data?.message ||
//           "Failed to process enrollment. Please try again."
//       );
//       setIsLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 overflow-y-auto">
//       <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
//         <div
//           className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
//           aria-hidden="true"
//           onClick={onClose}
//         ></div>

//         <span
//           className="hidden sm:inline-block sm:align-middle sm:h-screen"
//           aria-hidden="true"
//         >
//           &#8203;
//         </span>

//         <div className="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
//           <div className="absolute top-0 right-0 pt-4 pr-4">
//             <button
//               type="button"
//               className="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none"
//               onClick={onClose}
//             >
//               <span className="sr-only">Close</span>
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M6 18L18 6M6 6l12 12"
//                 />
//               </svg>
//             </button>
//           </div>

//           <div className="sm:flex sm:items-start">
//             <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
//               <h3
//                 className="text-lg font-bold leading-6 text-gray-900"
//                 id="modal-title"
//               >
//                 Enroll in {courseDetails.title}
//               </h3>

//               {/* Progress Indicator */}
//               <div className="w-full mt-4 mb-8">
//                 <div className="flex justify-between">
//                   <div
//                     className={`text-xs ${
//                       step >= 1 ? "text-gray-700 font-medium" : "text-gray-400"
//                     }`}
//                   >
//                     Personal Details
//                   </div>
//                   <div
//                     className={`text-xs ${
//                       step >= 2 ? "text-gray-700 font-medium" : "text-gray-400"
//                     }`}
//                   >
//                     Payment Options
//                   </div>
//                   <div
//                     className={`text-xs ${
//                       step >= 3 ? "text-gray-700 font-medium" : "text-gray-400"
//                     }`}
//                   >
//                     Review & Confirm
//                   </div>
//                 </div>
//                 <div className="relative w-full h-2 mt-2 bg-gray-200 rounded-full">
//                   <div
//                     className="absolute top-0 left-0 h-2 bg-gray-600 rounded-full transition-all duration-300"
//                     style={{ width: `${(step / 3) * 100}%` }}
//                   ></div>
//                 </div>
//               </div>

//               {/* Step 1: Personal Details */}
//               {step === 1 && (
//                 <div className="mt-4 space-y-4">
//                   <div>
//                     <label
//                       htmlFor="name"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Full Name <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="email"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Email Address <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="email"
//                       id="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="phone"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Phone Number <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       type="tel"
//                       id="phone"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       required
//                     />
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="address"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Address
//                     </label>
//                     <input
//                       type="text"
//                       id="address"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                     />
//                   </div>
//                   <div className="grid grid-cols-2 gap-4">
//                     <div>
//                       <label
//                         htmlFor="city"
//                         className="block text-sm font-medium text-gray-700"
//                       >
//                         City
//                       </label>
//                       <input
//                         type="text"
//                         id="city"
//                         name="city"
//                         value={formData.city}
//                         onChange={handleInputChange}
//                         className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       />
//                     </div>
//                     <div>
//                       <label
//                         htmlFor="state"
//                         className="block text-sm font-medium text-gray-700"
//                       >
//                         State
//                       </label>
//                       <input
//                         type="text"
//                         id="state"
//                         name="state"
//                         value={formData.state}
//                         onChange={handleInputChange}
//                         className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       />
//                     </div>
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="pincode"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       PIN Code
//                     </label>
//                     <input
//                       type="text"
//                       id="pincode"
//                       name="pincode"
//                       value={formData.pincode}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                     />
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="education"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       School/College Name
//                     </label>
//                     <input
//                       type="text"
//                       id="schoolName"
//                       name="schoolName"
//                       value={formData.schoolName}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       placeholder="e.g., SVMS High School"
//                     />
//                   </div>
//                   <div>
//                     <label
//                       htmlFor="education"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Studying Class (Ex: 8, 9, 10, etc.) or Highest Qualification
//                     </label>
//                     <input
//                       type="text"
//                       id="education"
//                       name="education"
//                       value={formData.education}
//                       onChange={handleInputChange}
//                       className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       placeholder="e.g., B.A. Political Science"
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Step 2: Payment Options */}
//               {step === 2 && (
//                 <div className="mt-4 space-y-6">
//                   <div className="p-4 bg-gray-50 rounded-md">
//                     <div className="flex justify-between items-center">
//                       <h4 className="text-base font-medium text-gray-900">
//                         Course Fee
//                       </h4>
//                       <span className="text-xl font-bold text-gray-900">
//                         {courseDetails.price}
//                       </span>
//                     </div>
//                     <p className="mt-1 text-sm text-gray-500">
//                       {courseDetails.title} - {courseDetails.duration}
//                     </p>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Payment Type
//                     </label>
//                     <div className="space-y-3">
//                       <div className="relative flex items-start">
//                         <div className="flex items-center h-5">
//                           <input
//                             id="full-payment"
//                             name="paymentType"
//                             type="radio"
//                             value="full"
//                             checked={formData.paymentType === "full"}
//                             onChange={handlePaymentTypeChange}
//                             className="h-4 w-4 text-gray-600 border-gray-300 focus:ring-gray-500"
//                           />
//                         </div>
//                         <div className="ml-3 text-sm">
//                           <label
//                             htmlFor="full-payment"
//                             className="font-medium text-gray-700"
//                           >
//                             Full Payment
//                           </label>
//                           <p className="text-gray-500">
//                             Pay the entire course fee at once
//                           </p>
//                         </div>
//                       </div>
//                       <div className="relative flex items-start">
//                         <div className="flex items-center h-5">
//                           <input
//                             id="part-payment"
//                             name="paymentType"
//                             type="radio"
//                             value="part"
//                             checked={formData.paymentType === "part"}
//                             onChange={handlePaymentTypeChange}
//                             className="h-4 w-4 text-gray-600 border-gray-300 focus:ring-gray-500"
//                           />
//                         </div>
//                         <div className="ml-3 text-sm">
//                           <label
//                             htmlFor="part-payment"
//                             className="font-medium text-gray-700"
//                           >
//                             Installment Payment
//                           </label>
//                           <p className="text-gray-500">
//                             Pay in multiple installments (5% processing fee
//                             applies)
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {formData.paymentType === "part" && (
//                     <div>
//                       <label
//                         htmlFor="installments"
//                         className="block text-sm font-medium text-gray-700 mb-2"
//                       >
//                         Number of Installments
//                       </label>
//                       <select
//                         id="installments"
//                         name="installments"
//                         value={installments}
//                         onChange={handleInstallmentsChange}
//                         className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                       >
//                         <option value="2">2 Installments</option>
//                         <option value="3">3 Installments</option>
//                         <option value="4">4 Installments</option>
//                       </select>
//                       <p className="mt-2 text-sm text-gray-500">
//                         First installment: ₹
//                         {calculateInstallmentAmount().toLocaleString()} (Due
//                         now)
//                       </p>
//                     </div>
//                   )}

//                   <div>
//                     <label
//                       htmlFor="couponCode"
//                       className="block text-sm font-medium text-gray-700"
//                     >
//                       Coupon Code (if any)
//                     </label>
//                     <div className="mt-1 flex">
//                       <input
//                         type="text"
//                         id="couponCode"
//                         name="couponCode"
//                         value={formData.couponCode}
//                         onChange={handleInputChange}
//                         className="block w-full px-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
//                         placeholder="Enter coupon code"
//                       />
//                       <button
//                         type="button"
//                         className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-r-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
//                       >
//                         Apply
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Step 3: Review & Confirm */}
//               {step === 3 && (
//                 <div className="mt-4 space-y-6">
//                   <div>
//                     <h4 className="text-base font-medium text-gray-900 mb-2">
//                       Enrollment Summary
//                     </h4>
//                     <div className="bg-gray-50 p-4 rounded-md space-y-3">
//                       <div className="flex justify-between">
//                         <span className="text-sm text-gray-500">Course</span>
//                         <span className="text-sm font-medium text-gray-900">
//                           {courseDetails.title}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span className="text-sm text-gray-500">Duration</span>
//                         <span className="text-sm font-medium text-gray-900">
//                           {courseDetails.duration}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span className="text-sm text-gray-500">
//                           Batch Type
//                         </span>
//                         <span className="text-sm font-medium text-gray-900">
//                           {courseDetails.batches}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span className="text-sm text-gray-500">
//                           Start Dates
//                         </span>
//                         <span className="text-sm font-medium text-gray-900">
//                           {courseDetails.startDates[0]}
//                         </span>
//                       </div>
//                       <div className="border-t border-gray-200 my-2 pt-2"></div>
//                       <div className="flex justify-between">
//                         <span className="text-sm text-gray-500">
//                           Payment Type
//                         </span>
//                         <span className="text-sm font-medium text-gray-900">
//                           {formData.paymentType === "full"
//                             ? "Full Payment"
//                             : `${installments} Installments`}
//                         </span>
//                       </div>
//                       {formData.paymentType === "part" && (
//                         <div className="flex justify-between">
//                           <span className="text-sm text-gray-500">
//                             Processing Fee (5%)
//                           </span>
//                           <span className="text-sm font-medium text-gray-900">
//                             ₹
//                             {(
//                               parseFloat(
//                                 courseDetails.price.replace(/[^\d.]/g, "")
//                               ) * 0.05
//                             ).toLocaleString()}
//                           </span>
//                         </div>
//                       )}
//                       <div className="border-t border-gray-200 my-2 pt-2"></div>
//                       <div className="flex justify-between">
//                         <span className="text-sm font-medium text-gray-900">
//                           {formData.paymentType === "part"
//                             ? "First Installment (Due Now)"
//                             : "Total Amount"}
//                         </span>
//                         <span className="text-base font-bold text-gray-900">
//                           ₹{calculateInstallmentAmount().toLocaleString()}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   <div>
//                     <h4 className="text-base font-medium text-gray-900 mb-2">
//                       Personal Details
//                     </h4>
//                     <div className="bg-gray-50 p-4 rounded-md space-y-3">
//                       <div className="grid grid-cols-2 gap-4">
//                         <div>
//                           <span className="text-sm text-gray-500">Name</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.name}
//                           </p>
//                         </div>
//                         <div>
//                           <span className="text-sm text-gray-500">Email</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.email}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="grid grid-cols-2 gap-4">
//                         <div>
//                           <span className="text-sm text-gray-500">School</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.schoolName}
//                           </p>
//                         </div>
//                         <div>
//                           <span className="text-sm text-gray-500">Class</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.education}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="grid grid-cols-2 gap-4">
//                         <div>
//                           <span className="text-sm text-gray-500">Phone</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.phone}
//                           </p>
//                         </div>
//                         <div>
//                           <span className="text-sm text-gray-500">
//                             Education
//                           </span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.education || "Not specified"}
//                           </p>
//                         </div>
//                       </div>
//                       {formData.address && (
//                         <div>
//                           <span className="text-sm text-gray-500">Address</span>
//                           <p className="text-sm font-medium text-gray-900">
//                             {formData.address}, {formData.city},{" "}
//                             {formData.state} {formData.pincode}
//                           </p>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="pt-2">
//                     <div className="relative flex items-start">
//                       <div className="flex items-center h-5">
//                         <input
//                           id="terms"
//                           name="terms"
//                           type="checkbox"
//                           className="h-4 w-4 text-gray-600 border-gray-300 rounded focus:ring-gray-500"
//                           required
//                         />
//                       </div>
//                       <div className="ml-3 text-sm">
//                         <label
//                           htmlFor="terms"
//                           className="font-medium text-gray-700"
//                         >
//                           I agree to the Terms & Conditions
//                         </label>
//                         <p className="text-gray-500">
//                           By proceeding, you agree to our{" "}
//                           <a href="/terms" className="text-gray-600 underline">
//                             Terms of Service
//                           </a>{" "}
//                           and{" "}
//                           <a
//                             href="/privacy"
//                             className="text-gray-600 underline"
//                           >
//                             Privacy Policy
//                           </a>
//                           .
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               <div className="mt-8 sm:flex sm:flex-row-reverse">
//                 {step < 3 ? (
//                   <button
//                     type="button"
//                     className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
//                     onClick={handleNextStep}
//                   >
//                     Next Step
//                   </button>
//                 ) : (
//                   <button
//                     type="button"
//                     className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
//                     onClick={handlePayment}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <svg
//                           className="w-5 h-5 mr-2 -ml-1 text-white animate-spin"
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                         Processing...
//                       </>
//                     ) : (
//                       "Proceed to Payment"
//                     )}
//                   </button>
//                 )}
//                 {step > 1 && (
//                   <button
//                     type="button"
//                     className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
//                     onClick={handlePrevStep}
//                   >
//                     Back
//                   </button>
//                 )}
//                 {step === 1 && (
//                   <button
//                     type="button"
//                     className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
//                     onClick={onClose}
//                   >
//                     Cancel
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EnrollmentModal;
// components/EnrollmentModal.jsx
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";
import { CONSTANTS } from "../constants/Constants";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

const EnrollmentModal = ({ isOpen, onClose, courseDetails }) => {
  const { currentUser, userDetails } = useAuth();
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [enrollmentDetails, setEnrollmentDetails] = useState(null);
  const [installments, setInstallments] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    education: "",
    paymentType: "full",
    couponCode: "",
    schoolName: "",
  });

  // Initialize form with user data if logged in
  useEffect(() => {
    if (userDetails) {
      setFormData({
        ...formData,
        name: `${userDetails.firstName || ""} ${
          userDetails.lastName || ""
        }`.trim(),
        email: userDetails.email || "",
        phone: userDetails.phone || "",
        address: userDetails.address || "",
        city: userDetails.city || "",
        state: userDetails.state || "",
        pincode: userDetails.pincode || "",
        education: userDetails.education || "",
      });
    }
  }, [userDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePaymentTypeChange = (e) => {
    setFormData({
      ...formData,
      paymentType: e.target.value,
    });
  };

  const handleInstallmentsChange = (e) => {
    setInstallments(parseInt(e.target.value));
  };

  const validateStep1 = () => {
    // Basic validation
    if (!formData.name || !formData.email || !formData.phone) {
      toast.error("Please fill all required fields");
      return false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Phone validation
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.phone.replace(/\D/g, ""))) {
      toast.error("Please enter a valid 10-digit phone number");
      return false;
    }

    return true;
  };

  const handleNextStep = () => {
    if (step === 1 && validateStep1()) {
      setStep(2);
    } else if (step === 2) {
      setStep(3);
    }
  };

  const handlePrevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const calculateInstallmentAmount = () => {
    const fullPrice = parseFloat(courseDetails.price.replace(/[^\d.]/g, ""));
    // Adding 5% processing fee for installments
    const totalWithFee =
      formData.paymentType === "part" ? fullPrice * 1.05 : fullPrice;

    if (formData.paymentType === "part") {
      return Math.ceil(totalWithFee / installments);
    }

    return totalWithFee;
  };

  const initializeRazorpay = async () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  // Function to store enrollment data in Firestore
  const storeEnrollmentInFirestore = async (
    enrollmentData,
    firestoreEnrollmentId = null
  ) => {
    try {
      const enrollmentDate = new Date();
      const expiryDate = new Date();
      expiryDate.setFullYear(enrollmentDate.getFullYear() + 1); // Add 1 year

      const firestoreData = {
        ...enrollmentData,
        language: courseDetails.language || "", // Add language field
        enrollmentDate: enrollmentDate,
        expiryDate: expiryDate,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        firestoreEnrollmentId: firestoreEnrollmentId, // Store the Firestore document ID reference
      };

      const docRef = await addDoc(collection(db, "enrollments"), firestoreData);
      console.log("Enrollment stored in Firestore with ID: ", docRef.id);

      return docRef.id;
    } catch (error) {
      console.error("Error storing enrollment in Firestore:", error);
      throw error;
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    setStep(1);
    setEnrollmentDetails(null);
    onClose();
  };

  const handleGoToDashboard = () => {
    window.location.href = "/dashboard";
  };

  const handlePayment = async () => {
    try {
      setIsLoading(true);

      // Initialize Razorpay
      const res = await initializeRazorpay();

      if (!res) {
        toast.error("Razorpay SDK failed to load");
        setIsLoading(false);
        return;
      }

      // Prepare enrollment data
      const enrollmentData = {
        userId: currentUser?.uid || null,
        courseId: courseDetails.id,
        courseTitle: courseDetails.title,
        language: courseDetails.language || "", // Add language field
        studentName: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        education: formData.education,
        schoolName: formData.schoolName,
        paymentType: formData.paymentType,
        totalInstallments: formData.paymentType === "part" ? installments : 1,
        currentInstallment: 1,
        amountPaid: 0,
        totalAmount: parseFloat(courseDetails.price.replace(/[^\d.]/g, "")),
        couponCode: formData.couponCode,
        status: "pending",
      };

      // Create an enrollment record and get order details
      const response = await axios.post(
        `${CONSTANTS.APIURL}/api/enrollments`,
        enrollmentData
      );
      console.log("Enrollment response:", response);

      const { orderId, amount, enrollmentId } = response.data;

      // Razorpay payment options
      const options = {
        key: "rzp_live_rFvA9VV5i4vRQV", // Replace with your actual Razorpay key
        amount: amount * 100, // Amount in paisa
        currency: "INR",
        name: "Skysep",
        description: `Enrollment for ${courseDetails.title}`,
        order_id: orderId,
        handler: async function (response) {
          try {
            // Verify payment and update enrollment status
            const paymentData = {
              enrollmentId,
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              signature: response.razorpay_signature,
            };

            await axios.post(
              `${CONSTANTS.APIURL}/api/enrollments/verify-payment`,
              paymentData
            );

            // Store enrollment data in Firestore after successful payment
            try {
              const firestoreEnrollmentId = await storeEnrollmentInFirestore({
                ...enrollmentData,
                status: "completed",
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                signature: response.razorpay_signature,
                backendEnrollmentId: enrollmentId, // Reference to backend enrollment ID
                amountPaid: amount,
              });

              console.log(
                "Enrollment successfully stored in Firestore with ID:",
                firestoreEnrollmentId
              );
            } catch (firestoreError) {
              console.error(
                "Failed to store enrollment in Firestore:",
                firestoreError
              );
              // Don't block the success flow, but log the error
              toast.warn(
                "Enrollment completed but failed to sync with cloud storage"
              );
            }

            // Set enrollment details for success modal
            setEnrollmentDetails({
              courseName: courseDetails.title,
              studentName: formData.name,
              email: formData.email,
              paymentId: response.razorpay_payment_id,
              amount: amount,
              enrollmentId: enrollmentId,
              paymentType: formData.paymentType,
              installments: formData.paymentType === "part" ? installments : 1,
              language: courseDetails.language,
              duration: courseDetails.duration,
              startDate: courseDetails.startDates[0],
            });

            setIsLoading(false);
            setShowSuccessModal(true);
          } catch (error) {
            console.error("Payment verification error:", error);
            toast.error("Payment verification failed. Please contact support.");
            setIsLoading(false);
          }
        },
        prefill: {
          name: formData.name,
          email: formData.email,
          contact: formData.phone,
        },
        notes: {
          enrollmentId,
          courseId: courseDetails.id,
          installment: `1/${
            formData.paymentType === "part" ? installments : 1
          }`,
        },
        theme: {
          color: "#4B5563",
        },
        modal: {
          ondismiss: function () {
            setIsLoading(false);
          },
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Enrollment error:", error);
      toast.error(
        error.response?.data?.message ||
          "Failed to process enrollment. Please try again."
      );
      setIsLoading(false);
    }
  };

  // Success Modal Component
  const SuccessModal = () => (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          aria-hidden="true"
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
          <div>
            <div className="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
              <svg
                className="w-6 h-6 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div className="mt-3 text-center sm:mt-5">
              <h3
                className="text-lg font-medium leading-6 text-gray-900"
                id="modal-title"
              >
                Enrollment Successful!
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Congratulations! You have successfully enrolled in the course.
                </p>
              </div>
            </div>
          </div>

          {enrollmentDetails && (
            <div className="mt-5">
              <div className="bg-gray-50 p-4 rounded-md space-y-3">
                <div className="text-center">
                  <h4 className="text-base font-medium text-gray-900 mb-2">
                    Enrollment Details
                  </h4>
                </div>

                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Course:</span>
                    <span className="font-medium text-gray-900">
                      {enrollmentDetails.courseName}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Student:</span>
                    <span className="font-medium text-gray-900">
                      {enrollmentDetails.studentName}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Duration:</span>
                    <span className="font-medium text-gray-900">
                      {enrollmentDetails.duration}
                    </span>
                  </div>

                  {enrollmentDetails.language && (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Language:</span>
                      <span className="font-medium text-gray-900">
                        {enrollmentDetails.language}
                      </span>
                    </div>
                  )}

                  <div className="flex justify-between">
                    <span className="text-gray-500">Start Date:</span>
                    <span className="font-medium text-gray-900">
                      {enrollmentDetails.startDate}
                    </span>
                  </div>

                  <div className="border-t border-gray-200 my-2 pt-2"></div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Payment ID:</span>
                    <span className="font-medium text-gray-900 text-xs">
                      {enrollmentDetails.paymentId}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-500">Amount Paid:</span>
                    <span className="font-medium text-gray-900">
                      ₹{enrollmentDetails.amount.toLocaleString()}
                    </span>
                  </div>

                  {enrollmentDetails.paymentType === "part" && (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Payment Plan:</span>
                      <span className="font-medium text-gray-900">
                        1 of {enrollmentDetails.installments} installments
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg
                      className="w-5 h-5 text-blue-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-blue-700">
                      A confirmation email has been sent to{" "}
                      <span className="font-medium">
                        {enrollmentDetails.email}
                      </span>
                      . Please check your inbox for course access details.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
            <button
              type="button"
              className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-green-600 border border-transparent rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:col-start-2 sm:text-sm"
              onClick={handleGoToDashboard}
            >
              Go to Dashboard
            </button>
            <button
              type="button"
              className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              onClick={handleCloseModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (!isOpen && !showSuccessModal) return null;

  // Show success modal if payment is successful
  if (showSuccessModal) {
    return <SuccessModal />;
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          aria-hidden="true"
          onClick={onClose}
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div className="absolute top-0 right-0 pt-4 pr-4">
            <button
              type="button"
              className="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none"
              onClick={onClose}
            >
              <span className="sr-only">Close</span>
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="sm:flex sm:items-start">
            <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
              <h3
                className="text-lg font-bold leading-6 text-gray-900"
                id="modal-title"
              >
                Enroll in {courseDetails.title}
              </h3>

              {/* Progress Indicator */}
              <div className="w-full mt-4 mb-8">
                <div className="flex justify-between">
                  <div
                    className={`text-xs ${
                      step >= 1 ? "text-gray-700 font-medium" : "text-gray-400"
                    }`}
                  >
                    Personal Details
                  </div>
                  <div
                    className={`text-xs ${
                      step >= 2 ? "text-gray-700 font-medium" : "text-gray-400"
                    }`}
                  >
                    Payment Options
                  </div>
                  <div
                    className={`text-xs ${
                      step >= 3 ? "text-gray-700 font-medium" : "text-gray-400"
                    }`}
                  >
                    Review & Confirm
                  </div>
                </div>
                <div className="relative w-full h-2 mt-2 bg-gray-200 rounded-full">
                  <div
                    className="absolute top-0 left-0 h-2 bg-gray-600 rounded-full transition-all duration-300"
                    style={{ width: `${(step / 3) * 100}%` }}
                  ></div>
                </div>
              </div>

              {/* Step 1: Personal Details */}
              {step === 1 && (
                <div className="mt-4 space-y-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="address"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label
                        htmlFor="city"
                        className="block text-sm font-medium text-gray-700"
                      >
                        City
                      </label>
                      <input
                        type="text"
                        id="city"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="state"
                        className="block text-sm font-medium text-gray-700"
                      >
                        State
                      </label>
                      <input
                        type="text"
                        id="state"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      />
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="pincode"
                      className="block text-sm font-medium text-gray-700"
                    >
                      PIN Code
                    </label>
                    <input
                      type="text"
                      id="pincode"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="education"
                      className="block text-sm font-medium text-gray-700"
                    >
                      School/College Name
                    </label>
                    <input
                      type="text"
                      id="schoolName"
                      name="schoolName"
                      value={formData.schoolName}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      placeholder="e.g., SVMS High School"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="education"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Studying Class (Ex: 8, 9, 10, etc.) or Highest
                      Qualification
                    </label>
                    <input
                      type="text"
                      id="education"
                      name="education"
                      value={formData.education}
                      onChange={handleInputChange}
                      className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      placeholder="e.g., B.A. Political Science"
                    />
                  </div>
                </div>
              )}

              {/* Step 2: Payment Options */}
              {step === 2 && (
                <div className="mt-4 space-y-6">
                  <div className="p-4 bg-gray-50 rounded-md">
                    <div className="flex justify-between items-center">
                      <h4 className="text-base font-medium text-gray-900">
                        Course Fee
                      </h4>
                      <span className="text-xl font-bold text-gray-900">
                        {courseDetails.price}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-gray-500">
                      {courseDetails.title} - {courseDetails.duration}
                      {courseDetails.language && (
                        <span> ({courseDetails.language})</span>
                      )}
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Payment Type
                    </label>
                    <div className="space-y-3">
                      <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="full-payment"
                            name="paymentType"
                            type="radio"
                            value="full"
                            checked={formData.paymentType === "full"}
                            onChange={handlePaymentTypeChange}
                            className="h-4 w-4 text-gray-600 border-gray-300 focus:ring-gray-500"
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label
                            htmlFor="full-payment"
                            className="font-medium text-gray-700"
                          >
                            Full Payment
                          </label>
                          <p className="text-gray-500">
                            Pay the entire course fee at once
                          </p>
                        </div>
                      </div>
                      {/* <div className="relative flex items-start">
                        <div className="flex items-center h-5">
                          <input
                            id="part-payment"
                            name="paymentType"
                            type="radio"
                            value="part"
                            checked={formData.paymentType === "part"}
                            onChange={handlePaymentTypeChange}
                            className="h-4 w-4 text-gray-600 border-gray-300 focus:ring-gray-500"
                          />
                        </div>
                        <div className="ml-3 text-sm">
                          <label
                            htmlFor="part-payment"
                            className="font-medium text-gray-700"
                          >
                            Installment Payment
                          </label>
                          <p className="text-gray-500">
                            Pay in multiple installments (5% processing fee
                            applies)
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  {formData.paymentType === "part" && (
                    <div>
                      <label
                        htmlFor="installments"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Number of Installments
                      </label>
                      <select
                        id="installments"
                        name="installments"
                        value={installments}
                        onChange={handleInstallmentsChange}
                        className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                      >
                        <option value="2">2 Installments</option>
                        <option value="3">3 Installments</option>
                        <option value="4">4 Installments</option>
                      </select>
                      <p className="mt-2 text-sm text-gray-500">
                        First installment: ₹
                        {calculateInstallmentAmount().toLocaleString()} (Due
                        now)
                      </p>
                    </div>
                  )}

                  <div>
                    <label
                      htmlFor="couponCode"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Coupon Code (if any)
                    </label>
                    <div className="mt-1 flex">
                      <input
                        type="text"
                        id="couponCode"
                        name="couponCode"
                        value={formData.couponCode}
                        onChange={handleInputChange}
                        className="block w-full px-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
                        placeholder="Enter coupon code"
                      />
                      <button
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-r-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3: Review & Confirm */}
              {step === 3 && (
                <div className="mt-4 space-y-6">
                  <div>
                    <h4 className="text-base font-medium text-gray-900 mb-2">
                      Enrollment Summary
                    </h4>
                    <div className="bg-gray-50 p-4 rounded-md space-y-3">
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">Course</span>
                        <span className="text-sm font-medium text-gray-900">
                          {courseDetails.title}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">Duration</span>
                        <span className="text-sm font-medium text-gray-900">
                          {courseDetails.duration}
                        </span>
                      </div>
                      {courseDetails.language && (
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-500">
                            Language
                          </span>
                          <span className="text-sm font-medium text-gray-900">
                            {courseDetails.language}
                          </span>
                        </div>
                      )}
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Batch Type
                        </span>
                        <span className="text-sm font-medium text-gray-900">
                          {courseDetails.batches}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Start Dates
                        </span>
                        <span className="text-sm font-medium text-gray-900">
                          {courseDetails.startDates[0]}
                        </span>
                      </div>
                      <div className="border-t border-gray-200 my-2 pt-2"></div>
                      <div className="flex justify-between">
                        <span className="text-sm text-gray-500">
                          Payment Type
                        </span>
                        <span className="text-sm font-medium text-gray-900">
                          {formData.paymentType === "full"
                            ? "Full Payment"
                            : `${installments} Installments`}
                        </span>
                      </div>
                      {formData.paymentType === "part" && (
                        <div className="flex justify-between">
                          <span className="text-sm text-gray-500">
                            Processing Fee (5%)
                          </span>
                          <span className="text-sm font-medium text-gray-900">
                            ₹
                            {(
                              parseFloat(
                                courseDetails.price.replace(/[^\d.]/g, "")
                              ) * 0.05
                            ).toLocaleString()}
                          </span>
                        </div>
                      )}
                      <div className="border-t border-gray-200 my-2 pt-2"></div>
                      <div className="flex justify-between">
                        <span className="text-sm font-medium text-gray-900">
                          {formData.paymentType === "part"
                            ? "First Installment (Due Now)"
                            : "Total Amount"}
                        </span>
                        <span className="text-base font-bold text-gray-900">
                          ₹{calculateInstallmentAmount().toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-base font-medium text-gray-900 mb-2">
                      Personal Details
                    </h4>
                    <div className="bg-gray-50 p-4 rounded-md space-y-3">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="text-sm text-gray-500">Name</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.name}
                          </p>
                        </div>
                        <div>
                          <span className="text-sm text-gray-500">Email</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.email}
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="text-sm text-gray-500">School</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.schoolName}
                          </p>
                        </div>
                        <div>
                          <span className="text-sm text-gray-500">Class</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.education}
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="text-sm text-gray-500">Phone</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.phone}
                          </p>
                        </div>
                        <div>
                          <span className="text-sm text-gray-500">
                            Education
                          </span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.education || "Not specified"}
                          </p>
                        </div>
                      </div>
                      {formData.address && (
                        <div>
                          <span className="text-sm text-gray-500">Address</span>
                          <p className="text-sm font-medium text-gray-900">
                            {formData.address}, {formData.city},{" "}
                            {formData.state} {formData.pincode}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="pt-2">
                    <div className="relative flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="terms"
                          name="terms"
                          type="checkbox"
                          className="h-4 w-4 text-gray-600 border-gray-300 rounded focus:ring-gray-500"
                          required
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="terms"
                          className="font-medium text-gray-700"
                        >
                          I agree to the Terms & Conditions
                        </label>
                        <p className="text-gray-500">
                          By proceeding, you agree to our{" "}
                          <a href="/terms" className="text-gray-600 underline">
                            Terms of Service
                          </a>{" "}
                          and{" "}
                          <a
                            href="/privacy"
                            className="text-gray-600 underline"
                          >
                            Privacy Policy
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-8 sm:flex sm:flex-row-reverse">
                {step < 3 ? (
                  <button
                    type="button"
                    className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={handleNextStep}
                  >
                    Next Step
                  </button>
                ) : (
                  <button
                    type="button"
                    className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={handlePayment}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <svg
                          className="w-5 h-5 mr-2 -ml-1 text-white animate-spin"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Processing...
                      </>
                    ) : (
                      "Proceed to Payment"
                    )}
                  </button>
                )}
                {step > 1 && (
                  <button
                    type="button"
                    className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={handlePrevStep}
                  >
                    Back
                  </button>
                )}
                {step === 1 && (
                  <button
                    type="button"
                    className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentModal;
